(function () {
    "use strict";

    angular.module('app').directive('fodbzText', FodbzTextDirective);

    function FodbzTextDirective() {
        return {
            require: '^ngModel',
            transclude: true,
            scope: {
                fodbzModel: '=',
                fodbzFieldConst: '@',
                fodbzField: '@',
                fodbzType: '@',
                fodbzInit: '@',
                fodbzValid: '@',
                fodbzMaxlength: '@',
                fodbzMinlength: '@',
                onChange: '&',
                fodbzMask: '@',
                fodbzDisabled: '='
            },
            controller: ['$scope', function ($scope) {
                $scope.fodbzType = angular.isDefined($scope.fodbzType) ? $scope.fodbzType : 'text';
                if ($scope.fodbzType === 'text') {
                    $scope.fodbzInit = angular.isDefined($scope.fodbzInit) ? $scope.fodbzInit : '';
                }
                else if ($scope.fodbzType === 'url') {
                    $scope.fodbzInit = angular.isDefined($scope.fodbzInit) ? $scope.fodbzInit : 'https://';
                }
                else if ($scope.fodbzType === 'number') {
                    $scope.fodbzInit = angular.isDefined($scope.fodbzInit) ? $scope.fodbzInit : '0';
                }
            }],
            template: `
                <input aria-describedby="{{fodbzFieldConst}}{{fodbzValid}}"
                       ng-disabled="fodbzDisabled"       
                       class="form-control"
                       id="{{fodbzFieldConst}}"
                       name="{{fodbzFieldConst}}"
                       maxlength="{{fodbzMaxlength}}"
                       minlength="{{fodbzMinlength}}"
                       ng-model="fodbzModel"
                       ng-model-options="{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }"
                       placeholder="{{fodbzInit}}"
                       type="{{fodbzType}}"
                       ui-mask="{{fodbzMask}}"
                       model-view-value="true">
                    `
        };
    }
})();
